import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import attachmentService from './attachmentService'

const initialState = {
  isScanning: false,
  isConfirming: false,
  isError: false,
  message: '',
}

// Upload a receipt/statement file, OCR it, get back a parsed preview
// (nothing is created yet - see confirmAttachment).
export const scanAttachment = createAsyncThunk(
  'attachments/scan',
  async ({ schedaId, file }, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      return await attachmentService.scanAttachment(schedaId, file, token)
    } catch (error) {
      const message = error.response?.data?.message || error.message || error.toString()
      return thunkAPI.rejectWithValue(message)
    }
  }
)

// Confirm the (possibly user-edited) parsed entries into real notaSpese.
export const confirmAttachment = createAsyncThunk(
  'attachments/confirm',
  async ({ schedaId, attachmentId, entries }, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token
      return await attachmentService.confirmAttachment(schedaId, attachmentId, entries, token)
    } catch (error) {
      const message = error.response?.data?.message || error.message || error.toString()
      return thunkAPI.rejectWithValue(message)
    }
  }
)

const attachmentSlice = createSlice({
  name: 'attachments',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(scanAttachment.pending, (state) => {
        state.isScanning = true
        state.isError = false
      })
      .addCase(scanAttachment.fulfilled, (state) => {
        state.isScanning = false
      })
      .addCase(scanAttachment.rejected, (state, action) => {
        state.isScanning = false
        state.isError = true
        state.message = action.payload
      })
      .addCase(confirmAttachment.pending, (state) => {
        state.isConfirming = true
        state.isError = false
      })
      .addCase(confirmAttachment.fulfilled, (state) => {
        state.isConfirming = false
      })
      .addCase(confirmAttachment.rejected, (state, action) => {
        state.isConfirming = false
        state.isError = true
        state.message = action.payload
      })
  },
})

export const { reset } = attachmentSlice.actions
export default attachmentSlice.reducer
